import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    productId: String,
    productName: String
  }

  connect() {
    if (this.hasProductIdValue && this.hasProductNameValue &&
      typeof gtag === 'function') {
      gtag('event', 'product_view', {
        item_id: this.productIdValue,
        item_name: this.productNameValue,
      })
    }
  }

  addToCart(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'add_to_cart', {
        item_id: this.productIdValue,
        item_name: this.productNameValue,
        // Add more properties as needed
      })
    }
  }
}